export const villkorItem = { value: 'tab1', href: '', label: 'Villkor' } as const;
export const personuppgifterItem = { value: 'tab2', href: '/personuppgifter', label: 'Personuppgifter' } as const;
export const spelreglerItem = { value: 'tab3', href: '/spelregler', label: 'Spelregler' } as const;

export const navItems = [villkorItem, personuppgifterItem, spelreglerItem];

const isDev = process.env.NODE_ENV !== 'production';
const customerServiceHref = isDev ? '/kundservice-smart-faq' : '/kundservice';

export const PAGE_TEXT = {
  intro: {
    title: 'Villkor, personuppgifter och spelregler',
    description:
      'Här kan du läsa om våra villkor, hur vi behandlar dina personuppgifter och vilka regler som gäller för våra spel.',
  },
  sectionHeadings: {
    villkor: {
      title: 'Villkor',
      description: 'Läs mer om vad som gäller när du använder våra tjänster och spelar hos oss.',
    },
    personuppgifter: {
      title: 'Personuppgifter',
      description: 'Läs mer om hur vi behandlar dina personuppgifter.',
    },
    spelregler: {
      title: 'Spelregler',
      description: 'Läs mer om reglerna för varje spel.',
    },
  },
  faq: {
    heading: 'Har du frågor eller funderingar?',
    buttonText: 'Kontakta kundservice',
    buttonHref: customerServiceHref,
  },
  accordion: {
    emptyState: 'Tyvärr hittades inga vanliga frågor.',
  },
  documents: {
    emptyState: 'Tyvärr hittades inga dokument.',
  },
  errors: {
    contentFetchFailed: 'Innehållet kunde inte hämtas just nu. Försök igen senare.',
  },
};
